export const DISH_TYPES = {
  BREAKFAST: 1,
  LUNCH: 2,
  DINNER: 3,
};
